module.exports = __webpack_public_path__ + "static/9-536a4edcc6f118a4635902c4df7aeb1c.jpg";